module.exports = __webpack_public_path__ + "static/media/wizualizacja-128.5351538d.png";